import { Routes } from '@angular/router';
import { AuthGuardAutoLogin } from '@nx-vigil/core/web/auth/feature';
import { conditionalInsert } from '@nx-vigil/core/web/shared/util';
import {
  MasterDetailComponent,
  NavigationChildComponent,
} from '@nx-vigil/core/web/shell/ui';
import { CentralShellComponent } from './central-shell.component';

const defaultRoute = 'devices';

export function getRoutes(features: { [key: string]: boolean }): Routes {
  return [
    {
      path: '',
      component: CentralShellComponent,
      children: [
        ...conditionalInsert(features['dashboard'], {
          path: 'dashboard',
          title: 'Dashboard',
          data: {
            icon: 'home',
          },
          component: NavigationChildComponent,
          canActivate: [AuthGuardAutoLogin],
          children: [],
        }),
        ...conditionalInsert(features['devices'], {
          path: 'devices',
          title: 'Devices',
          data: {
            icon: 'dns',
          },
          canActivate: [AuthGuardAutoLogin],
          loadChildren: () =>
            import('@nx-vigil/central/web/device/feature').then(
              module => module.featureRoutes,
            ),
        }),
        ...conditionalInsert(features['users'], {
          path: 'users',
          title: 'Users',
          data: {
            icon: 'people',
          },
          component: NavigationChildComponent,
          canActivate: [AuthGuardAutoLogin],
          children: [
            {
              path: 'server',
              title: 'Server User Group',
              component: MasterDetailComponent,
            },
            {
              path: 'central',
              title: 'Central Users',
              component: MasterDetailComponent,
            },
            {
              path: '',
              redirectTo: 'server',
              pathMatch: 'full',
            },
          ],
        }),
        ...conditionalInsert(features['jobs'], {
          path: 'jobs',
          title: 'Jobs & Updates',
          data: {
            icon: 'code',
          },
          component: NavigationChildComponent,
          canActivate: [AuthGuardAutoLogin],
          children: [],
        }),
        ...conditionalInsert(features['profiles'], {
          path: 'profiles',
          title: 'Profiles',
          data: {
            icon: 'bookmarks',
          },
          component: NavigationChildComponent,
          canActivate: [AuthGuardAutoLogin],
          children: [],
        }),
        {
          path: '',
          redirectTo: defaultRoute,
          pathMatch: 'full',
        },
        {
          path: '**',
          redirectTo: defaultRoute,
          pathMatch: 'full',
        },
      ],
    },
  ];
}
